export default __webpack_public_path__ + "static/media/edit-icon.a4288032.svg";